const vendorGeneral = (() => {
    let vendorID;
    let vendorEntriesById;
    let isReadOnly = false;
    let vendorClassificationEntries = [{ text: '', value: '' },
        { text: 'Agency', value: 'Y' },
        { text: 'Independent', value: 'N' }];
    let vendorTypes;
    async function init(vendorId) {
        PROGRESS__ANYWHERE.init();
        const actioncenter = document.getElementById('actioncenter');
        PROGRESS__ANYWHERE.SPINNER.show(actioncenter,'');

        vendorID = vendorId;      
        if (vendorID === 0) {
            if ($.session.authorizationInsertVendorInfo) isReadOnly = false;
            else if (!$.session.authorizationInsertVendorInfo) isReadOnly = true;
        }
        else if (vendorID > 0) {
            if ($.session.authorizationsVendorInfoUpdate) isReadOnly = false;
            else if (!$.session.authorizationsVendorInfoUpdate) isReadOnly = true;
        }
        const vendorTypeResult = await authorizationsAjax.getVendorTypeDropdownData();
        vendorTypes = JSON.parse(vendorTypeResult.getVendorTypeDropdownDataResult);
        if (vendorID > 0) {            
            vendorEntriesById = await authorizationsAjax.getVendorEntriesByIdAsync(vendorID);
        }
        else {           
            vendorEntriesById = {
                getVendorEntriesByIdResult: [{
                    name: '', DBA: '', contactName: '', contactPhone: '', contactEmail: '', address1: '', address2: '', city: '',
                    state: '', zipCode: '', primaryPhone: '', providerFirstName: '', providerLastName: '', providerBirthDate: '',
                    providerBuildingNumber: '', salesforceId: '', DDStateNumber: '', ein: '', submitterId: '', LocalNumber: '', ssn: '',
                    sender: '', MHStateNumber: '', TDDStateNumber: '', NPI: '', MHNPI: '', goodStanding: 'N', takingNewReferrals: '', FSSVendor: 'N',
                    sanctionsAdministered: 'N', homeServices: 'N', classification: '', vendorType: '',
                }]
            };
        }
    }

    function getMarkup() {
        const workScheduleWrap = document.createElement('div');
        workScheduleWrap.classList.add('planSummary');

        const importantTables = buildVendorGeneralForm();
        workScheduleWrap.appendChild(importantTables);

        return workScheduleWrap;
    }

    function buildVendorGeneralForm() {
        const vendor = vendorEntriesById?.getVendorEntriesByIdResult[0];
        const employeeInfoDiv = document.createElement('div');       
        employeeInfoDiv.classList.add('additionalQuestionWrap');        
        const nameInput = input.build({
            id: 'name',
            type: 'text',
            label: 'Name',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '100' }, { key: 'data-originalValue', value: vendor?.name }],
            value: vendor?.name,            
        });
        const classificationDropdown = dropdown.build({
            id: 'classification',
            label: 'Classification',
            dropdownId: 'classification',          
            value: '',
            readonly: isReadOnly
        });
        dropdown.populate(classificationDropdown, vendorClassificationEntries, vendor?.classification);
        const dbaInput = input.build({
            id: 'DBA',
            type: 'text',
            label: 'Doing Business As',
            style: 'secondary',
            readonly: isReadOnly,
            value: vendor?.DBA, 
            attributes: [{ key: 'maxlength', value: '100' }, { key: 'data-originalValue', value: vendor?.DBA }],            
        });
        const vendorTypeDropdown = dropdown.build({
            id: 'vendorType',
            label: 'Vendor Type',
            dropdownId: 'vendorType', 
            readonly: isReadOnly
        });       
        const vendorTypeData = vendorTypes.map(item => {
            return { text: item.vendorName, value: item.vendorId }
        });
        vendorTypeData.unshift({ text: '', value: '' });
        dropdown.populate(vendorTypeDropdown, vendorTypeData, vendor?.vendorType);
        const contactNameInput = input.build({
            id: 'contactName',
            type: 'text',
            label: 'Contact Name',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '100' }, { key: 'data-originalValue', value: vendor?.contactName }],
            value: vendor?.contactName,
        });
        const contactPhoneInput = input.build({
            id: 'contactPhone',
            type: 'text',
            label: 'Contact Phone',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '14' }, { key: 'data-originalValue', value: vendor?.contactPhone }],
            value: vendor?.contactPhone,
        });
        const contactEmailInput = input.build({
            id: 'contactEmail',
            type: 'text',
            label: 'Contact Email',
            readonly: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'maxlength', value: '200' }, { key: 'data-originalValue', value: vendor?.contactEmail }],
            value: vendor?.contactEmail,
        });
        const address1Input = input.build({
            id: 'address1',
            type: 'text',
            label: 'Address 1',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '50' }, { key: 'data-originalValue', value: vendor?.address1 }],
            value: vendor?.address1,
        });
        const address2Input = input.build({
            id: 'address2',
            type: 'text',
            label: 'Address 2',
            readonly: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'maxlength', value: '50' }, { key: 'data-originalValue', value: vendor?.address2 }],
            value: vendor?.address2,
        });
        const cityInput = input.build({
            id: 'city',
            type: 'text',
            label: 'City',
            readonly: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'maxlength', value: '30' }, { key: 'data-originalValue', value: vendor?.city }],
            value: vendor?.city,
        });
        const stateInput = input.build({
            id: 'state',
            type: 'text',
            label: 'State',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '2' }, { key: 'data-originalValue', value: vendor?.state }],
            value: vendor?.state,
        });
        const zipInput = input.build({
            id: 'zipCode',
            type: 'text',
            label: 'Zip Code',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '10' }, { key: 'data-originalValue', value: vendor?.zipCode }],
            value: vendor?.zipCode,
        });
        const phoneInput = input.build({
            id: 'primaryPhone',
            type: 'text',
            label: 'Phone',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '14' }, { key: 'data-originalValue', value: vendor?.primaryPhone }],
            value: vendor?.primaryPhone,
        });
        const firstNameInput = input.build({
            id: 'providerFirstName',
            type: 'text',
            label: 'First Name',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '40' }, { key: 'data-originalValue', value: vendor?.providerFirstName }],
            value: vendor?.providerFirstName,
        });
        const lastNameInput = input.build({
            id: 'providerLastName',
            type: 'text',
            label: 'Last Name',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '80' }, { key: 'data-originalValue', value: vendor?.providerLastName }],
            value: vendor?.providerLastName,
        });
        const providerBirthDate = (vendor?.providerBirthDate || '') === '' ? '' : moment(vendor?.providerBirthDate).format('MM/DD/YYYY');
        const birthDateInput = input.build({
            id: 'providerBirthDate',
            type: 'date',
            label: 'Birth Date',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'max', value: '9999-12-31' }, { key: 'data-originalValue', value: providerBirthDate }],
            value: vendor?.providerBirthDate? moment(vendor.providerBirthDate).format('YYYY-MM-DD'): '',
        });
        const buildingNumberInput = input.build({
            id: 'providerBuildingNumber',
            type: 'text',
            label: 'Building Number',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '40' }, { key: 'data-originalValue', value: vendor?.providerBuildingNumber }],
            value: vendor?.providerBuildingNumber,
        });
        const salesforceIDInput = input.build({
            id: 'salesforceId',
            type: 'text',
            label: 'Salesforce ID',
            style: 'secondary',
            readonly: true,
            attributes: [{ key: 'maxlength', value: '20' }],
            value: vendor?.salesforceId,
        });
        const DDStateNumberInput = input.build({
            id: 'DDStateNumber',
            type: 'text',
            label: 'DD State Number',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '30' }, { key: 'data-originalValue', value: vendor?.DDStateNumber }],
            value: vendor?.DDStateNumber,
        });
        const einInput = input.build({
            id: 'ein',
            type: 'text',
            label: 'EIN',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '9' }, { key: 'data-originalValue', value: vendor?.ein }],
            value: vendor?.ein,
        });
        const submitterInput = input.build({
            id: 'submitterId',
            type: 'text',
            label: 'Submitter',
            readonly: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'maxlength', value: '80' }, { key: 'data-originalValue', value: vendor?.submitterId }],
            value: vendor?.submitterId,
        });
        const localNumberInput = input.build({
            id: 'LocalNumber',
            type: 'text',
            label: 'Local Number',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '20' }, { key: 'data-originalValue', value: vendor?.LocalNumber }],
            value: vendor?.LocalNumber,
        });
        const SSNInput = input.build({
            id: 'ssn',
            type: 'text',
            label: 'SSN',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '9' }, { key: 'data-originalValue', value: vendor?.ssn }],
            value: vendor?.ssn,
        });
        const senderInput = input.build({
            id: 'sender',
            type: 'text',
            label: 'Sender ',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '80' }, { key: 'data-originalValue', value: vendor?.sender }],
            value: vendor?.sender,
        });
        const MHStateNumberInput = input.build({
            id: 'MHStateNumber',
            type: 'text',
            label: 'MH State Number',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '30' }, { key: 'data-originalValue', value: vendor?.MHStateNumber }],
            value: vendor?.MHStateNumber,
        });
        const TDDStateNumberInput = input.build({
            id: 'TDDStateNumber',
            type: 'text',
            label: 'TDD State Number',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '20' }, { key: 'data-originalValue', value: vendor?.TDDStateNumber }],
            value: vendor?.TDDStateNumber,
        });
        const NPIInput = input.build({
            id: 'NPI',
            type: 'text',
            label: 'NPI',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '10' }, { key: 'data-originalValue', value: vendor?.NPI }],
            value: vendor?.NPI,
        });
        const MHNPIInput = input.build({
            id: 'MHNPI',
            type: 'text',
            label: 'MH NPI',
            style: 'secondary',
            readonly: isReadOnly,
            attributes: [{ key: 'maxlength', value: '10' }, { key: 'data-originalValue', value: vendor?.MHNPI }],
            value: vendor?.MHNPI,
        });

        const inGoodStandingchkBox = input.buildCheckbox({
            text: 'In Good Standing',
            id: 'goodStanding',
            isChecked: vendor?.goodStanding == 'Y' ? true : false,
            isDisabled: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'data-originalValue', value: (vendor?.goodStanding||'N') }],
        });
        const takingNewReferralschkBox = input.buildCheckbox({
            text: 'Taking New Referrals',
            id: 'takingNewReferrals',
            isChecked: vendor?.takingNewReferrals == 'Y' ? true : false,
            isDisabled: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'data-originalValue', value: (vendor?.takingNewReferrals||'N') }],
        });
        const FSSVendorchkBox = input.buildCheckbox({
            text: 'FSS Vendor',
            id: 'FSSVendor',
            isChecked: vendor?.FSSVendor == 'Y' ? true : false,
            isDisabled: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'data-originalValue', value: (vendor?.FSSVendor ||'N')}],
        });
        const sanctionsAdministeredchkBox = input.buildCheckbox({
            text: 'Sanctions Administered',
            id: 'sanctionsAdministered',
            isChecked: vendor?.sanctionsAdministered == 'Y' ? true : false,
            isDisabled: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'data-originalValue', value: (vendor?.sanctionsAdministered || 'N') }],
        });
        const inHomeServiceschkBox = input.buildCheckbox({
            text: 'In Home Services',
            id: 'homeServices',
            isChecked: vendor?.homeServices == 'Y' ? true : false,
            isDisabled: isReadOnly,
            style: 'secondary',
            attributes: [{ key: 'data-originalValue', value: (vendor?.homeServices||'N') }],
        });


        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCardBody.id = 'employeeInfoDiv';
        addNewCard.innerHTML = `<div class="card__header">General</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        const consumerNameDisplay = document.createElement("p");
        consumerNameDisplay.classList.add("heading");
        consumerNameDisplay.innerHTML = `<span>${'Contact Information'}</span>`;
        addNewCardBody.appendChild(consumerNameDisplay);       
       
        const row1 = document.createElement('div');
        row1.classList.add('marginTop2Per');
        row1.style.display = 'grid';
        row1.style.gridTemplateColumns = '1fr 1fr';
        row1.style.gap = '10px';       
        row1.style.width = '100%';
        row1.appendChild(nameInput);
        row1.appendChild(classificationDropdown);
        addNewCardBody.appendChild(row1);

        const row2 = document.createElement('div');
        row2.style.display = 'grid';
        row2.style.gridTemplateColumns = '1fr 1fr';
        row2.style.gap = '10px';        
        row2.style.width = '100%';
        row2.appendChild(dbaInput);
        row2.appendChild(vendorTypeDropdown);
        addNewCardBody.appendChild(row2);        

        var dropWrap = document.createElement('div');
        dropWrap.classList.add('vendorDTWrap');
        contactNameInput.classList.add('width35Per');
        dropWrap.appendChild(contactNameInput);
        contactPhoneInput.classList.add('width30Per');
        dropWrap.appendChild(contactPhoneInput);
        contactEmailInput.classList.add('width30Per'); 
        dropWrap.appendChild(contactEmailInput);
        addNewCardBody.appendChild(dropWrap);

        var dropWrap1 = document.createElement('div');
        dropWrap1.classList.add('vendorDTWrap');
        address1Input.classList.add('width50Per');
        dropWrap1.appendChild(address1Input);
        address2Input.classList.add('width50Per');
        dropWrap1.appendChild(address2Input);
        addNewCardBody.appendChild(dropWrap1);

        var dropWrap2 = document.createElement('div');
        dropWrap2.classList.add('vendorDTWrap');
        cityInput.classList.add('width30Per');
        dropWrap2.appendChild(cityInput);
        stateInput.classList.add('width10Per');
        dropWrap2.appendChild(stateInput);
        zipInput.classList.add('width20Per');
        dropWrap2.appendChild(zipInput);
        phoneInput.classList.add('width32Per');
        dropWrap2.appendChild(phoneInput);
        addNewCardBody.appendChild(dropWrap2);

        const consumerNameDisplay1 = document.createElement("p");
        consumerNameDisplay1.classList.add("heading");
        consumerNameDisplay1.innerHTML = `<span>${'Ohio ISP Information'}</span>`;
        addNewCardBody.appendChild(consumerNameDisplay1);

        var dropWrap3 = document.createElement('div');
        dropWrap3.classList.add('marginTop2Per');
        dropWrap3.classList.add('vendorDTWrap');
        firstNameInput.classList.add('width25Per');
        dropWrap3.appendChild(firstNameInput);
        lastNameInput.classList.add('width23Per');
        dropWrap3.appendChild(lastNameInput);
        birthDateInput.classList.add('width23Per');
        dropWrap3.appendChild(birthDateInput);
        buildingNumberInput.classList.add('width23Per');
        dropWrap3.appendChild(buildingNumberInput);
        addNewCardBody.appendChild(dropWrap3);

        var dropWrap4 = document.createElement('div');
        dropWrap4.classList.add('vendorDTWrap');
        salesforceIDInput.classList.add('width40Per');
        dropWrap4.appendChild(salesforceIDInput);
        addNewCardBody.appendChild(dropWrap4);

        const consumerNameDisplay2 = document.createElement("p");
        consumerNameDisplay2.classList.add("heading");
        consumerNameDisplay2.innerHTML = `<span>${'Billing/Authorization'}</span>`;
        addNewCardBody.appendChild(consumerNameDisplay2);

        var dropWrap5 = document.createElement('div');
        dropWrap5.classList.add('marginTop2Per');
        dropWrap5.classList.add('vendorDTWrap');
        DDStateNumberInput.classList.add('width19Per');
        dropWrap5.appendChild(DDStateNumberInput);
        einInput.classList.add('width18Per');
        dropWrap5.appendChild(einInput);
        submitterInput.classList.add('width18Per');
        dropWrap5.appendChild(submitterInput);
        localNumberInput.classList.add('width18Per');
        dropWrap5.appendChild(localNumberInput);
        SSNInput.classList.add('width18Per');
        dropWrap5.appendChild(SSNInput);
        addNewCardBody.appendChild(dropWrap5);

        var dropWrap6 = document.createElement('div');
        dropWrap6.classList.add('vendorDTWrap');
        senderInput.classList.add('width19Per');
        dropWrap6.appendChild(senderInput);
        MHStateNumberInput.classList.add('width18Per');
        dropWrap6.appendChild(MHStateNumberInput);
        TDDStateNumberInput.classList.add('width18Per');
        dropWrap6.appendChild(TDDStateNumberInput);
        NPIInput.classList.add('width18Per');
        dropWrap6.appendChild(NPIInput);
        MHNPIInput.classList.add('width18Per');
        dropWrap6.appendChild(MHNPIInput);
        addNewCardBody.appendChild(dropWrap6);

        const consumerNameDisplay3 = document.createElement("p");
        consumerNameDisplay3.classList.add("heading");
        consumerNameDisplay3.innerHTML = `<span>${'Miscellaneous'}</span>`;
        addNewCardBody.appendChild(consumerNameDisplay3);

        var chkDiv = document.createElement('div');
        chkDiv.classList.add('marginTop2Per');
        chkDiv.appendChild(inGoodStandingchkBox);
        addNewCardBody.appendChild(chkDiv);

        var chkDiv1 = document.createElement('div');
        chkDiv1.appendChild(takingNewReferralschkBox);
        addNewCardBody.appendChild(chkDiv1);

        var chkDiv2 = document.createElement('div');
        chkDiv2.appendChild(FSSVendorchkBox);
        addNewCardBody.appendChild(chkDiv2);

        var chkDiv3 = document.createElement('div');
        chkDiv3.appendChild(sanctionsAdministeredchkBox);
        addNewCardBody.appendChild(chkDiv3);

        var chkDiv4 = document.createElement('div');
        chkDiv4.appendChild(inHomeServiceschkBox);
        addNewCardBody.appendChild(chkDiv4);

        employeeInfoDiv.appendChild(column1);
        const saveBtn = button.build({
            id: 'vendorSave',
            text: 'Save',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                let postData = {};
                postData['vendorID'] = vendorID;
                const employeeInfoDiv = document.getElementById('employeeInfoDiv');
                const inputs = employeeInfoDiv.querySelectorAll('input, select, textarea');
          
                inputs.forEach((inp) => {
                    if (inp.type === 'checkbox') {
                        postData[inp.id] = inp.checked ? 'Y' : 'N';
                    }
                    else {
                        postData[inp.id] = inp.value;
                    }
                });               
                try {
                    const result = await authorizationsAjax.saveAuthorizationVendor(postData);
                    const saveResult = result.saveAuthorizationVendorResult;
                    if (saveResult > 0) {
                        successfulSave.show(vendorID > 0 ?'Updated':'Saved');
                        setTimeout(function () {
                            successfulSave.hide();
                            if (vendorID === 0) {
                                vendorID = saveResult;
                                newVendorInfo.refreshVendor(vendorID, postData.DDStateNumber, postData.LocalNumber, postData.primaryPhone, postData.name);
                            }
                        }, 2000);
                    }
                    else if (saveResult === 'exists') {
                        showAlreadyExistsWarning();
                    }
                }
                catch {
                    failSave.show('An error occured');
                    setTimeout(() => { failSave.hide(); }, 2000);
                }
            },
        });
        saveBtn.classList.add('disabled');
        const cancelBtn = button.build({
            id: 'vendorCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: async () => {
                await vendorInfo.vendorInfoLoad();
            },
        });
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.style.width = '25%';
        btnWrap.style.float = 'right';
        btnWrap.style.marginTop = '15px';
        if (!isReadOnly) {           
            saveBtn.textContent = vendorID > 0 ? 'Update' : 'Save';
            btnWrap.appendChild(saveBtn);
        }
        btnWrap.appendChild(cancelBtn);
        addNewCardBody.appendChild(btnWrap);   
        function validateForm(isChanged) {
            if (!isReadOnly) {
                if (employeeInfoDiv.querySelector('#name').value === null
                    || employeeInfoDiv.querySelector('#name').value === '') {
                    nameInput.classList.add('error');
                }
                else {
                    nameInput.classList.remove('error');
                }
                if (employeeInfoDiv.querySelector('#classification').value === null
                    || employeeInfoDiv.querySelector('#classification').value === '') {
                    classificationDropdown.classList.add('error');
                }
                else {
                    classificationDropdown.classList.remove('error');
                }
                if (employeeInfoDiv.querySelector('#vendorType').value === null
                    || employeeInfoDiv.querySelector('#vendorType').value === '') {
                    vendorTypeDropdown.classList.add('error');
                }
                else {
                    vendorTypeDropdown.classList.remove('error');
                }

                var hasErrors = [].slice.call(employeeInfoDiv.querySelectorAll('.error:not(button)'));
                if (hasErrors.length === 0) {
                    saveBtn.classList.remove('disabled');
                    isChanged = isChanged || false;                   
                    if (vendorID > 0 && !isChanged) {
                        saveBtn.classList.add('disabled');
                    }
                } else {
                    saveBtn.classList.add('disabled');
                }               
            }
        }
        validateForm();

        employeeInfoDiv.querySelectorAll('#classification')[0]?.setAttribute('data-originalvalue', vendor?.classification);
        employeeInfoDiv.querySelectorAll('#vendorType')[0]?.setAttribute('data-originalvalue', vendor?.vendorType);
        const inputs = employeeInfoDiv.querySelectorAll(
            'input:not([disabled]):not([readonly]), select:not([disabled]):not([readonly]), textarea:not([disabled]):not([readonly])'
        ); 
        inputs.forEach(input => {           
            input.addEventListener("change", (e) => {              
                let isChanged = Array.from(inputs).some(el => {
                    let changed = false;
                    if (el.type === 'checkbox') changed = (el.dataset.originalvalue !== (el.checked ? 'Y' : 'N'));
                    else if (el.type === 'date') changed = (el.dataset.originalvalue !== (el.value ? moment(el.value).format('MM/DD/YYYY') : ''));
                    else changed = (el.dataset.originalvalue !== el.value);
                  
                    return changed;
                });
              
                validateForm(isChanged);
            });
        });
        
        PROGRESS__ANYWHERE.SPINNER.hide();
        return employeeInfoDiv;
    }  
    function showAlreadyExistsWarning() {
        var warningPopup = POPUP.build({});
        warningPopup.classList.add('warning');
        var message = document.createElement('p');
        message.innerHTML = 'A vendor already exists with this name.';
        message.style.marginBottom = '15px';
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var okBtn = button.build({
            text: 'Ok',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(warningPopup);              
            }
        });

        btnWrap.appendChild(okBtn);
        warningPopup.appendChild(message);
        warningPopup.appendChild(btnWrap);
        POPUP.show(warningPopup);
        warningPopup.querySelector('.closePopupBtn').remove();
    }
    return {
        init,
        buildVendorGeneralForm,
        getMarkup,       
    };
})(); 
